import { EGeoType } from 'shared/repositories/geo/entities/Geocoding/GeoCodedSearchDetails';
import { EObjectType } from 'shared/repositories/geo/entities/Geocoding/GeoLocationCatalogLink';
import { ILocation } from '../location';
import { ISuggestRequest } from 'shared/repositories/geo-suggest/v2/suggest';

export type TGeoType =
  | 'location'
  | 'street'
  | 'highway'
  | 'district'
  | 'underground'
  | 'house'
  | 'newobject'
  | 'builder'
  | 'railway'
  | 'village'
  | 'regional_district_id';

export interface IGeoSuggestItem<T> {
  title: string;
  value: T;
  subTitle?: string;
  externalLink?: string;
}

export type TGeoSuggestItemType = 1 | 2 | 3 | 4 | 5;

export const GeoSuggestItemType = {
  Address: 1 as const,
  Newbuilding: 2 as const,
  BSCenter: 3 as const,
  Highway: 4 as const,
  Railway: 5 as const,
};

export interface IGeocodeCachedResult {
  text?: string;
  name?: string;
  kind?: YMaps.TGeoKind;
  coordinates: YMaps.TCoord;
  boundedBy: [YMaps.TCoord, YMaps.TCoord];
}

export interface IGeoLocationCatalogLink {
  id: number;
  objectType: EObjectType;
}

export type TGeocodeForSearchGeoType =
  | 'Country'
  | 'Location'
  | 'Street'
  | 'Road'
  | 'District'
  | 'Underground'
  | 'House';

export interface IGeocodeForSearchResponse {
  geo: {
    lat?: number;
    lng?: number;
  };
  geoLocationCatalogLink?: IGeoLocationCatalogLink;
  text?: string;
  isParsed: boolean;
  details?: IGeoDetail[];
  countryId: number;
  regionId?: number;
  microDistricts?: {
    fullName?: string;
    hasBoundaries: boolean;
    id: number;
    locationFullName?: string;
    locationId: number;
    name?: string;
    nativeName?: string;
  }[];
}

export interface IGeoDetail {
  id: number;
  name?: string;
  fullName?: string;
  geoType: EGeoType;
  locationInfo?: {
    text?: string;
    hasMetro: boolean;
    hasHighway: boolean;
    hasDistricts: boolean;
    parentId?: number;
    mainTownId?: number;
    lat: number;
    lng: number;
    boundedBy: {
      lowerCorner: {
        lat: number;
        lng: number;
      };
      upperCorner: {
        lat: number;
        lng: number;
      };
    };
  };
}

export interface IGeoDistrict {
  id: number;
  name: string;
  type: 'Raion' | 'Okrug' | 'MikroRaion';
  childs: IGeoDistrict[];
  direction: {
    code: number | null;
    name: string | null;
  };
}

export interface IGeoDistrictsTreeResponse {
  data: IGeoDistrict[];
}

export interface IDistrict {
  name: string;
  id: number;
}

export interface IGeoObject {
  type: TGeoType;
  id: number;
  text: string;
  coordinates?: YMaps.TCoord;
  regionId: number;
  locationId?: number;
  locationInfo?: ILocation;
  district?: IDistrict;
}

export interface IPolygonObject extends IGeoObject {
  polygon: YMaps.TCoord[];
}

export interface ICircleObject extends IGeoObject {
  center: YMaps.TCoord;
  radius: number;
}

export type TGeoObject = IGeoObject | IPolygonObject | ICircleObject;

export interface ISelectKPParams {
  id: number;
  name: string;
  regionId?: number;
}

export interface ISelectBSCenterParams {
  id: number;
  name: string;
}

export interface ISelectCoworkingParams {
  id: number;
  name: string;
}

export interface IAddressSuggestionOptions {
  boundedBy: [YMaps.TCoord, YMaps.TCoord] | undefined;
  results: number;
}

export interface IMultiSuggestParams {
  structured: ISuggestRequest;
  yandex: {
    value: string;
    options?: IAddressSuggestionOptions;
  };
}
